module.exports = __webpack_public_path__ + "img/Weapon_77.7d3fb6c8.png";